<script setup>
import { defineModel, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import MultiSelect from './MultiSelect.vue';

const { options } = defineProps({
  options: {
    type: Array,
    required: true,
  },
});

const { t } = useI18n();
const transition = defineModel({
  type: Object,
  required: true,
});

const fromValue = computed({
  get: () => transition.value?.from || [],
  set: value => {
    transition.value = {
      ...transition.value,
      from: value,
    };
  },
});

const toValue = computed({
  get: () => transition.value?.to || [],
  set: value => {
    transition.value = {
      ...transition.value,
      to: value,
    };
  },
});
</script>

<template>
  <div class="flex items-center gap-2">
    <div class="flex items-center gap-1.5">
      <label class="text-xs text-n-slate-11 flex-shrink-0">
        {{ t('AUTOMATION.STATE_TRANSITION.FROM') }}
      </label>
      <MultiSelect v-model="fromValue" :options="options" :max-chips="2" />
    </div>
    <div class="flex items-center gap-1.5">
      <label class="text-xs text-n-slate-11 flex-shrink-0">
        {{ t('AUTOMATION.STATE_TRANSITION.TO') }}
      </label>
      <MultiSelect v-model="toValue" :options="options" :max-chips="2" />
    </div>
  </div>
</template>
